import React, { useId } from "react";
import { ChevronRight } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import { formatDay } from "../../utils/analyticsLabels";
import { formatCount } from "../charts/format";

// Os destaques (spec do redesign, R6): o numero primeiro, uma frase, e o separador onde se age. O
// cartao inteiro e o botao, e a pagina leva ao sitio (`onGo`), porque e ela que conhece a barra fixa e o
// painel. Os de atencao tem o numero em ambar; o verde fica para o que melhorou (R1).
const FIGURE_COLORS = { attention: "var(--color-delta-bad-text)", context: "var(--color-text-primary)" };

const figureText = (figure, language) => {
  if (figure.type === "hour") return `${figure.value}h`;
  if (figure.type === "percent") return `${figure.value}%`;
  if (figure.type === "change") return `${figure.value < 0 ? "−" : "+"}${Math.abs(figure.value)}%`;
  return formatCount(figure.value, language);
};

const formatParams = (params, language) =>
  Object.fromEntries(
    Object.entries(params).map(([key, value]) => {
      if (key === "day") return [key, formatDay(value, language)];
      return [key, typeof value === "number" ? formatCount(value, language) : value];
    })
  );

const HighlightCards = ({ items, onGo }) => {
  const { translate, language } = useLanguage();
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} className="space-y-3">
      <h2 id={headingId} className="text-base font-semibold" style={{ color: "var(--color-text-primary)" }}>
        {translate("analyticsHighlights")}
      </h2>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => onGo(item.tab)}
            className="text-left rounded-xl border p-4 flex flex-col gap-2"
            style={{ borderColor: "var(--color-border)", backgroundColor: "var(--color-surface)" }}
          >
            <span className="text-2xl font-semibold tabular-nums" style={{ color: FIGURE_COLORS[item.tone] }}>
              {figureText(item.figure, language)}
            </span>
            <span className="text-sm" style={{ color: "var(--color-text-primary)" }}>
              {translate(item.message, formatParams(item.params, language))}
            </span>
            <span className="mt-auto inline-flex items-center gap-1 text-sm font-medium" style={{ color: "var(--color-text-secondary)" }}>
              {translate(`analyticsGoTo.${item.tab}`)}
              <ChevronRight className="w-4 h-4" aria-hidden="true" />
            </span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default HighlightCards;
